<div id="content" class="allcp-form" ng-controller="StockMovementController" ng-init="get()">
	<div ng-include="'modules/company/menus/stock_menu.html'"></div>
	<div class="row mt20">
		<div class="panel">

			<div class="panel-heading">
				<span class="panel-title"> Stok Güncelle</span>
				<hr>
			</div>
			
			<div class="panel-body pn">
				<div class="col-md-7">
					<form ng-submit="update()" class="form-horizontal allcp-form">
				
						<div class="form-group">
							<label class="col-md-3 control-label">
								Stok Adı / Seri no
							</label>
							<div class="col-md-9">
								<label for="name21" class="field">
									<div angucomplete-alt
										name="customer_name"
										ng-model="data.stockMovement.stock.name"
										placeholder="Stok Adı / Seri no"
										pause="100"
										selected-object="stockSelected"
										remote-url="api/find-stock?s="
										remote-url-data-field="stocks"
										search-fields="id,name,serial_number"
										title-field="name"
										description-field="serial_number"
										minlength="1"
										input-class="form-control input-md"
										match-class="highlight"
										>
									</div>
								</label>
							</div>
						</div>


						<div class="form-group">
							<label class="col-md-3 control-label">
								Bağlı OlduğuKargo
							</label>
							<div class="col-md-9">
								<label for="name21" class="field">
									<div angucomplete-alt
										name="order"
										ng-model="data.stockMovement.order.id"
										placeholder="Kargo No"
										pause="100"
										selected-object="orderSelected"
										remote-url="api/find-order?s="
										remote-url-data-field="orders"
										search-fields="id,name"
										title-field="id"
										description-field="name"
										minlength="1"
										input-class="form-control input-md"
										match-class="highlight"
										>
									</div>
								</label>
							</div>
						</div>

						<div class="form-group">
							<label class="col-md-3 control-label">
								İşlem Türü * 
							</label>
							<div class="col-md-9">
								<label for="name21" class="field">
									<select ng-model="data.stockMovement.part_type" class="form-control" required>
										<option value="Değiştirme">Değiştirme</option>
										<option value="Onarım">Onarım</option>
									</select>
								</label>
							</div>
						</div>

						<div class="form-group">
							<label class="col-md-3 control-label">
								Miktar * 
							</label>
							<div class="col-md-9">
								<label for="name21" class="field">
									<input type="number" ng-model="data.stockMovement.piece" class="gui-input br-light light" placeholder="Miktar" required>
								</label>
							</div>
						</div>

						<div class="form-group">
							<label class="col-md-3 control-label">
								Hareket * 
							</label>
							<div class="col-md-9">
								<label for="name21" class="field">
									<select ng-model="data.stockMovement.type" class="form-control" required>
										<option value="0">Hareket Yok</option>
										<option value="-1">Çıkış</option>
										<option value="1">Giriş</option>
									</select>
								</label>
							</div>
						</div>
	
						<div class="form-group">
							<label class="col-md-3 control-label">
								Açıklama
							</label>
							<div class="col-md-9">
								<label for="name21" class="field prepend-icon">
									<textarea ng-model="data.stockMovement.description" class="form-control" placeholder="Açıklama" cols="30" rows="5"></textarea>
									<label for="name21" class="field-icon">
										<i class="fa fa-list-alt"></i>
									</label>
								</label>
							</div>
						</div>

						<div class="form-group">
							<div class="col-md-12">
								<button type="submit" class="btn btn-primary pull-right"><span class="fa fa-save"></span> Kaydet</a>
							</div>
						</div>

					</form>
				</div>
			</div>
		</div>
	</div>
</div>